'use strict';

import {http, clearElements} from '../utils';
import History from '../navigation/history.class';
import dispatcher from '../dispatcher';

const parser = new DOMParser();


export class ContentMore extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._isLoading = false;
    this._contentLoaded = +this.dataset.loaded || 0;
    this._maxContent = +this.dataset.max || 24;
    this._count = +this.dataset.count || 6;
    this._url = this.dataset.url || '';
  }
  connectedCallback() {
    this._filterForm = this.querySelector('.contentMoreFilterForm');
    this._filterSet = this.querySelector('.contentMoreFilterSet');
    this._button = this.querySelector('.contentMoreButton');
    this._wrapper = this.querySelector('.contentMoreWrapper');

    this._filterForm.addEventListener('submit', evt => evt.preventDefault());
    this._filterSet.addEventListener('change', evt => this._get(true));

    this._button.addEventListener('click', evt => this._count < this._maxContent && this._get());

    this._filterForm.addEventListener('wheel', (e) => {
      e.preventDefault();

      this._filterForm.scrollLeft += e.deltaY;
    });
  }
  disconnectedCallback() {
  }

  async _get(clear = false) {
    if (this._isLoading) return;
    this._isLoading = true;

    const data = new FormData(this._filterForm);

    const count = clear ? 0 : this._contentLoaded;
    data.append('countStart', count.toString());
    data.append('countEnd', (count + this._count).toString());

    this.classList.add('loading');
    this._filterSet.setAttribute('disabled', 'true');

    try {
      const response = await http({
        action: this._url,
        data: data
      });

      if (clear) {
        clearElements(this._wrapper);
      }

      const doc = parser.parseFromString(response.content, 'text/html');
      const elements = doc.querySelectorAll('.cases-group');

      Array.from(elements).forEach(el => this._wrapper.appendChild(el));

      History.push({
        state: {
          title: response.title,
          href: response.url,
        },
        title: response.title,
        href: response.url,
      });

      this._contentLoaded = clear ? response.loaded : this._contentLoaded + response.loaded;
      this._maxContent = response.max;

      if (this._count >= this._maxContent) {
        this._button.classList.add('disabled');
      } else {
        this._button.classList.remove('disabled');
      }

      setTimeout(() => dispatcher.dispatch({
        type: 'mutate',
        halfUpdate: true
      }), 10);

      this._end();
    } catch (error) {
      console.log(error);

      this._end();
    }
  }
  _end() {
    this.classList.remove('loading');
    this._filterSet.removeAttribute('disabled');
    this._isLoading = false;
  }
}


window.customElements.define('content-more', ContentMore);